var FEATURES = {
    GUEST_CHECKOUT: 'guest-checkout',
    DELIVERY: 'delivery',
};
export default FEATURES;



//////////////////
// WEBPACK FOOTER
// ./src/utils/Features.ts
// module id = s1p0
// module chunks = 18